<input
  type="checkbox"
  [id]="inputId()"
  [(ngModel)]="value"
  [disabled]="disabled()"
/>
<label
  [for]="inputId()"
  [class.isEnabled]="value()"
  [style.--color]="color()"
  [class.disabled]="disabled()"
></label>
@if (title()) {
  <span class="toggle-title">{{ title() }}</span>
}
